"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactToOfferButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_use_1 = require("react-use");
const StickyButton_1 = require("@src/components/elements/StickyButton/StickyButton");
const ReactToOfferButton = ({ sendResumeButtonRef }) => {
    const intl = (0, react_intl_1.useIntl)();
    const intersection = (0, react_use_1.useIntersection)(sendResumeButtonRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0.01,
    });
    const shouldBeActive = !(((intersection === null || intersection === void 0 ? void 0 : intersection.intersectionRatio) || 0) > 0);
    return ((0, jsx_runtime_1.jsx)(StickyButton_1.StickyButton, { onClick: () => {
            var _a;
            (_a = sendResumeButtonRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }, shape: "round", placement: "bottom-left", type: "success", 
        // I want to hide the button if it's intersecting the form
        // and leave the showing logic up to the element component if not
        isActive: shouldBeActive ? undefined : shouldBeActive, children: intl.formatMessage({ id: 'offer_detail.react_to_offer_button' }) }));
};
exports.ReactToOfferButton = ReactToOfferButton;
